import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { routingActionType, routingDashboardModuleType, routingModuleType, routingOrganizerModuleType, routingOrganizationSubModuleType, routingInteractionsModuleType, routingBusinessModuleType, routingCollaborationModuleType, routingFeaturesModuleType, routingFeaturesSubModuleType, routingBusinessSubModuleType } from 'src/app/shared/enums/module-types';
import { CommonService } from 'src/app/shared/services/common.service';
import { SharedService } from 'src/app/shared/services/shared.service';

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html'
})
export class MenuComponent implements OnInit {
    model: any = [];
    phase:any
    constructor(
        public common_service: CommonService,
        public shared_service: SharedService,
        public router: Router
    ) { 
       
    }
    ngOnInit() {
        this.shared_service.accountSettings$.subscribe(value => {
            this.phase = value;
            this.model = [
                {
                    label: 'Dashboards',
                    icon: 'pi pi-home',
                    language_key: 'lbl_dashboard',
                    visible: true,
                    module_id: 1,
                    items: [
                        {
                            label: 'Analytics Dashboard',
                            icon: 'pi pi-fw pi-chart-pie',
                            language_key: 'lbl_analytics_dashboard',
                            visible: true,
                            sub_module_id: 1,
                            routerLink: ['/' + routingModuleType.dashboard + '/' + routingDashboardModuleType.analytics]
                        },
                        {
                            label: 'SaaS Dashboard',
                            icon: 'pi pi-fw pi-bolt',
                            language_key: 'lbl_saas_dashboard',
                            visible: true,
                            sub_module_id: 2,
                            routerLink: ['/' + routingModuleType.dashboard + '/' + routingDashboardModuleType.saas]
                        },
                        {
                            label: 'Sales Dashboard',
                            icon: 'pi pi-fw pi-home',
                            language_key: 'lbl_sales_dashboard',
                            visible: true,
                            sub_module_id: 3,
                            routerLink: ['/' + routingModuleType.dashboard + '/' + routingDashboardModuleType.sales]
                        },
                    ]
                },
                {
                    label: 'Interactions',
                    icon: 'pi pi-sitemap',
                    language_key: 'lbl_interactions',
                    visible: true,
                    module_id: 2,
                    items: [
                        {
                            label: 'Clients',
                            icon: 'pi pi-user',
                            language_key: 'lbl_clients',
                            visible: true,
                            sub_module_id: 1,
                            routerLink: ['/' + routingModuleType.interactions + '/' + routingInteractionsModuleType.clients],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        },
                        {
                            label: 'Contacts',
                            icon: 'pi pi-credit-card',
                            language_key: 'lbl_contacts',
                            visible: true,
                            sub_module_id: 2,
                            routerLink: ['/' + routingModuleType.interactions + '/' + routingInteractionsModuleType.contacts],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        }
                    ]
                },
                {
                    label: 'Collaborations',
                    icon: 'pi pi-slack',
                    language_key: 'lbl_collaboration',
                    module_id: 4,
                    visible: true,
                    items: [
                        {
                            label: 'Jobs',
                            icon: 'pi pi-fw pi-briefcase',
                            language_key: 'lbl_jobs',
                            visible: true,
                            sub_module_id: 1,
                            routerLink: ['/' + routingModuleType.collaboration + '/' + routingCollaborationModuleType.jobs],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        },
                        {
                            label: 'Timesheets',
                            icon: 'pi pi-hourglass',
                            language_key: 'lbl_timesheets',
                            visible: true,
                            sub_module_id: 2,
                            routerLink: ['/' + routingModuleType.collaboration + '/' + routingCollaborationModuleType.timesheets],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        }/* ,
                        {
                            label: 'Timesheets Lock Period',
                            icon: 'pi pi-lock',
                            language_key: 'lbl_timesheets_lock_period',
                            visible: true,
                            sub_module_id: 3,
                            routerLink: ['/' + routingModuleType.collaboration + '/' + routingCollaborationModuleType.timesheet_lock],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        } */
                    ]
                },
                {
                    label: 'Business',
                    icon: 'pi pi-bitcoin',
                    language_key: 'lbl_business',
                    visible: true,
                    module_id: 3,
                    items: [
                        {
                            label: 'Quotes',
                            icon: 'pi pi-book',
                            language_key: 'lbl_quotes',
                            visible: true,
                            sub_module_id: 1,
                            routerLink: ['/' + routingModuleType.business + '/' + routingBusinessModuleType.quotes],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        },
                        {
                            label: 'Invoices',
                            icon: 'pi pi-hashtag',
                            language_key: 'lbl_invoices',
                            visible: true,
                            sub_module_id: 2,
                            routerLink: ['/' + routingModuleType.business + '/' + routingBusinessModuleType.invoices],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        },
                        {
                            label: 'Payments',
                            icon: 'pi pi-money-bill',
                            language_key: 'lbl_payments',
                            visible: true,
                            sub_module_id: 3,
                            routerLink: ['/' + routingModuleType.business + '/' + routingBusinessModuleType.payments],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        },
                        {
                            label: 'Adjustments',
                            icon: 'pi pi-file-edit',
                            language_key: 'lbl_adjustments',
                            visible: true,
                            sub_module_id: 4,
                            routerLink: ['/' + routingModuleType.business + '/' + routingBusinessModuleType.adjustments],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        },
                        {
                            label: 'Billing History',
                            icon: 'pi pi-history',
                            language_key: 'lbl_billing_history',
                            visible: true,
                            sub_module_id: 5,
                            routerLink: ['/' + routingModuleType.business + '/' + routingBusinessModuleType.billing_history],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        }
                    ]
                },
                {
                    label: 'Organization',
                    icon: 'pi pi-fw pi-microsoft',
                    visible: true,
                    language_key: 'lbl_organization',
                    module_id: 5,
                    items: [
                        {
                            label: 'Settings',
                            icon: 'pi pi-fw pi-cog',
                            language_key: 'lbl_settings',
                            visible: true,
                            sub_module_id: 1,
                            routerLink: ['/' + routingModuleType.organization + '/' + routingOrganizationSubModuleType.settings],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        },
                        {
                            label: 'Number sequence',
                            icon: 'pi pi-fw pi-list',
                            language_key: 'lbl_number_sequences',
                            visible: true,
                            sub_module_id: 2,
                            routerLink: ['/' + routingModuleType.organization + '/' + routingOrganizationSubModuleType.number_sequences]
                        },
                        {
                            label: 'Client Types',
                            icon: 'pi pi-fw pi-user',
                            language_key: 'lbl_client_types',
                            visible: true,
                            sub_module_id: 3,
                            routerLink: ['/' + routingModuleType.organization + '/' + routingOrganizationSubModuleType.client_types]
                        },
                        {
                            label: 'Quote States',
                            icon: 'pi pi-fw pi-book',
                            language_key: 'lbl_quote_states',
                            visible: true,
                            sub_module_id: 4,
                            routerLink: ['/' + routingModuleType.organization + '/' + routingOrganizationSubModuleType.quote_states]
                        },
                        {
                            label: 'Job Setup',
                            icon: 'pi pi-fw pi-briefcase',
                            language_key: 'lbl_job_setup',
                            visible: true,
                            sub_module_id: 5,
                            routerLink: ['/' + routingModuleType.organization + '/' + routingOrganizationSubModuleType.job_setup],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        },
                        {
                            label: 'Staffs',
                            icon: 'pi pi-fw pi-users',
                            language_key: 'lbl_staffs',
                            visible: true,
                            sub_module_id: 6,
                            routerLink: ['/' + routingModuleType.organization + '/' + routingOrganizationSubModuleType.staffs],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        },
                        // {
                        //     label: 'Teams',
                        //     icon: 'pi pi-slack',
                        //     language_key:'lbl_teams',
                        //     visible: true,
                        //     sub_module_id: 7,
                        //     routerLink: ['/' + routingModuleType.organization   + '/' + routingOrganizationSubModuleType.teams],
                        //     routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        // },
                        {
                            label: 'Tasks',
                            icon: 'pi pi-fw pi-sliders-v',
                            language_key: this.phase.account_task_heading,
                            visible: true,
                            sub_module_id: 8,
                            routerLink: ['/' + routingModuleType.organization + '/' + routingOrganizationSubModuleType.tasks],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        },
                        {
                            label: 'Expenses',
                            icon: 'pi pi-fw pi-dollar',
                            language_key: this.phase.account_cost_heading,
                            visible: true,
                            sub_module_id: 9,
                            routerLink: ['/' + routingModuleType.organization + '/' + routingOrganizationSubModuleType.costs],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        },
                        {
                            label: 'Roles',
                            icon: 'pi pi-fw pi-book',
                            language_key: 'lbl_roles',
                            visible: true,
                            sub_module_id: 10,
                            routerLink: ['/' + routingModuleType.organization + '/' + routingOrganizationSubModuleType.roles],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        }
                    ]
                },
                {
                    label: 'Feautures',
                    icon: 'pi pi-fw pi-angle-double-up',
                    visible: true,
                    language_key: 'lbl_features',
                    module_id: 6,
                    items: [
                        {
                            label: 'Custom Fields',
                            icon: 'pi pi-fw pi-arrows-alt',
                            language_key: 'lbl_custom_fields',
                            visible: true,
                            sub_module_id: 1,
                            routerLink: ['/' + routingOrganizerModuleType.features + '/' + routingFeaturesModuleType.customfields],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        },
                        {
                            label: 'Custom Templates',
                            icon: 'pi pi-envelope',
                            language_key: 'lbl_custom_templates',
                            visible: true,
                            sub_module_id: 2,
                            routerLink: ['/' + routingOrganizerModuleType.features + '/' + routingFeaturesModuleType.customtemplates],
                            routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        },
                        // {
                        //     label: 'Invoice Templates',
                        //     icon: 'pi pi-table',
                        //     language_key: 'lbl_invoice_templates',
                        //     visible: true,
                        //     sub_module_id: 3,
                        //     routerLink: ['/' + routingOrganizerModuleType.features + '/' + routingFeaturesModuleType.invoicetemplates],
                        //     routerLinkActiveOptions: { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
                        // }
                    ]
                }
            ];
            this.common_service.menuPermission(this.model);
          })
    }
}
